import * as React from 'react';
import { connect } from 'react-redux';

import { openModal } from 'store/Modal/actionCreators';
import RcaActionsCell from 'components/Rca/RcaActionsCell';

const mapDispatchToProps = {
    openModal
};

export default connect(null, mapDispatchToProps)(RcaActionsCell);
